module.exports = __webpack_public_path__ + "img/monitor.9d20fc36.svg";